import './assets/styles/styles.scss'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './container/app';

ReactDOM.render(

    <App />,

document.getElementById('root'))